<script lang="ts">
  import { Footer, type FooterProps } from '@stickerapp-org/athena/Footer';
  import { storyblokEditable } from '@storyblok/svelte';
  import { getLocalizationContext } from '@athena-lib/i18n';
  import { getUrlByLinkType, getNameByLinkType } from '$lib/utilities/storyblok';
  import type { FooterStoryblokWithMarkets } from '$lib/server/expanders/footer';
  import { getUrl } from '$lib/i18n';

  const localizationContext = getLocalizationContext();

  const showCookieConsentSettings = () => {
    window.UC_UI?.showSecondLayer();
  };

  const { blok }: { blok: FooterStoryblokWithMarkets } = $props();
  const footerProps: FooterProps = $derived({
    action: storyblokEditable,
    sites:
      blok.markets.map((m) => ({
        name: m.domain.substring(0, 1).toUpperCase() + m.domain.substring(1),
        url: getUrl('/', localizationContext.language, m).toString(),
      })) ?? [],
    onChangeSite: (site) => {
      window.location.href = site.url;
    },
    linkCollections:
      blok.linkCollections?.map((lc) => ({
        ...lc,
        actionArg: lc,
        heading: lc.heading ?? '',
        links:
          lc.links?.map((l) => ({
            ...l,
            text: getNameByLinkType({ link: l.linkUrl, text: l.text }),
            link: getUrlByLinkType(l.linkUrl),
            action:
              l.linkUrl?.cached_url === '#cookie-settings' ? showCookieConsentSettings : undefined,
          })) ?? [],
      })) ?? [],
    socialMediaIcons:
      blok.socialMediaIcons
        ?.filter((smi) => !!smi.icon && !!smi.linkUrl)
        .map((smi) => ({
          actionArg: smi,
          icon: { url: smi.icon!.filename, alt: smi.icon!.alt || '' },
          link: getUrlByLinkType(smi.linkUrl),
        })) ?? [],
    paymentProviderIcons:
      blok.paymentProviderIcons
        ?.filter((ppi) => !!ppi.icon && !!ppi.linkUrl)
        .map((ppi) => ({
          actionArg: ppi,
          icon: { url: ppi.icon!.filename, alt: ppi.icon!.alt || '' },
          link: getUrlByLinkType(ppi.linkUrl),
        })) ?? [],
    newsletterSignupClass: blok.newsletterSignupClassName ?? '',
  });
</script>

<Footer {...footerProps} />
